export const capitalizeWords = (text: string) =>
  text
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const formatSalePrice = (amount: number): string => {
  return `EGP ${amount?.toLocaleString() || '0'}`;
};

export const formatSaleInfo = (sale: any): string => {
  const propertyType = sale?.propertyType?.name ;
  const compoundName = sale?.compound?.name;
  const location = sale?.area?.name;
  return `${propertyType} in ${location} • ${compoundName}`;
};
